/* @ngInject */
export default function AccessControlService($sails, $q, $log) {
  const vm = this;

  vm.getStatus = getStatus;
  vm.getOptions = getOptions;
  vm.performAction = performAction;
  vm.processCurrentOption = processCurrentOption;

  function performAction({ id }, action) {
    return $sails.post(`/equipment/${id}/actions/${action}`, {
      id
    })
      .catch(catchError);
  }

  /**
   * Gets the status of the panel from the server.
   *
   * @param {object} equipment object
   * @param {string} equipment.id
   * @returns {Promise<object>} Status
   */
  function getStatus({ id }) {
    return $sails.get(`/equipment/${id}/statuses/getDoorState`)
      .then(success => processCurrentOption(success.data))
      .catch(catchError);
  }

  function processCurrentOption(values) {
    return { currentOption: values.doorMode };
  }

  function getOptions() {
    return [{
      name: 'Blocked',
      value: 'blocked',
      action: 'blockDoor',
      description: 'This door will not be unlocked even if a valid credential is presented.'
    }, {
      name: 'Locked',
      value: 'locked',
      action: 'lockDoor',
      description: 'A valid credential will unlock the door.'
    }, {
      name: 'Unlocked',
      value: 'unlocked',
      action: 'unlockDoor',
      description: 'No credentials needed.'
    }];
  }

  // private functions
  function catchError(error) {
    $log.log('Error: ', error);
    return $q.reject(error.data);
  }
}
